import { combineReducers } from "redux";

import home from "./home";
import user from './user';

export const reducers = combineReducers({
  home,
  user
});
